<template>
    <div>
        <b-card v-if="token==''"
            header="Ingreso de colonos"
            header-tag="header"
            footer-tag="footer"
            >
            <b-form @submit.prevent="ingresar" id="formLogin" autocomplete="off">
                <b-form-input
                    v-model="usuario"
                    class="mb-2"
                    @change="limpiarMensaje"
                    placeholder="Usuario"
                    name="usuario"
                    required
                />
    
                <b-form-input
                    v-model="password"
                    type="password"
                    class="mb-2"
                    placeholder="Constraseña"
                    name="password"
                    required
                />
    
                <b-row class="text-center mt-3">
                    <b-col>
                        <b-link to="/olvido" :disabled="token!=''"><small>¿Olvido su contraseña?</small></b-link>
                    </b-col>
                </b-row>
    
                <b-alert v-show="mensajeError != ''" variant="danger" show>{{ mensajeError }}</b-alert>
                <b-button type="submit" variant="outline-secondary" class="form-control"><b-icon-door-open></b-icon-door-open> Ingresar</b-button>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import Loading from "vue-loading-overlay";

export default {
    components: {
        Loading,
    },
    data () {
        return {
            mensajeError: '',
            usuario: '',
            password: '',
            //
        }
    },
    methods: {
        limpiarMensaje() {
            this.mensajeError = ''
        },
        ingresar() {
            this.mensajeError = ''

            const formData = new FormData()
            formData.append("accion", "inicioSesion")

            axios.post(`${process.env.VUE_APP_PRESTA_API_URL}/ajax/ajax.usuarios.php`, formData, {
                headers: {
                    Authorization: 'Basic ' + btoa(this.usuario + ':' + this.password)
                }
            })
            .then(res => {
                if (res.data.estado == 'ok') {
                    this.$toasted.success("Logueado con exito!", { duration : 2000 });

                    const usuario = {
                        "idUsuario": res.data.idUsuario,
                        "tipoUsuario": res.data.tipoUsuario,
                        "ciw": res.data.ciw,
                        "emailUsuario": res.data.emailUsuario,
                        "token": res.data.token
                    }

                    this.updUsuario(usuario)

                    if (this.$listeners.retornar) {
                        this.$emit("retornar")
                    }
                } else {
                    this.mensajeError = res.data.mensaje
                }
            })
        },
        ...mapActions(['updUsuario'])
    },
    computed: {
        ...mapState(['token'])
    }
}

</script>

<style scoped>
</style>